<template>
  <div class="">
    <div class="flex space-x-4 border-b mb-4 bg-white p-4 rounded shadow">
      <router-link
        :to="`/admin/devices/${$route.params.deviceId}/logs`"
        class="pb-2"
        :class="{ 'text-blue-600 border-b-2 border-blue-600': $route.path.includes('logs') }"
      >
        Logs
      </router-link>  
     

    </div>

    <router-view />
  </div>
</template>

<script>

export default {
};
</script>